<template>
  <div>
    <el-row>
      <el-col :span="24">
        <el-page-header @back="onBack" title="" content="設定 - 自動升級時間">
        </el-page-header>
      </el-col>
    </el-row>
    <div class="page-box">
      <el-form label-position="left" label-width="180px" :hide-required-asterisk="true" ref="ruleForm"  :model="formLabelAlign">
        <el-form-item>
          <div slot="label">
            <div class="label-text">現時提醒升級時間 : 每年</div>
          </div>
          <span>{{formLabelAlign.confirmUpgradeDate}}</span>
        </el-form-item>
        <el-form-item prop="confirmUpgrade" :rules="[{
          required: true,
          message: '請選擇升級時間',
          trigger: 'blur'
        }]">
          <div slot="label">
            <div class="label-text">更新提醒升級時間 : 每年<span class="star-mark"> *</span></div>
          </div>
           <el-date-picker
                v-model="formLabelAlign.confirmUpgrade"
                type="date"
                format=" MM 月 dd 日"
                value-format="MM-dd"
                placeholder="選擇日期">
                </el-date-picker>
        </el-form-item>
        <el-form-item>
          <div slot="label">
            <div class="label-text">現時自動升級時間 : 每年</div>
          </div>
          <span>{{formLabelAlign.autoUpgradeDate}}</span>
        </el-form-item>
      
        <el-form-item prop="autoUpgrade" :rules="[{
          required: true,
          message: '請選擇日期',
          trigger: 'blur'
        }]">
          <div slot="label">
            <div class="label-text">更新自動升級時間 : 每年 <span class="star-mark"> *</span></div>
          </div>
              <el-date-picker
                v-model="formLabelAlign.autoUpgrade"
                type="date"
                format=" MM 月 dd 日"
                value-format="MM-dd"
                placeholder="選擇日期">
                </el-date-picker>
        </el-form-item>
        <div class="page-button">
          <el-button type="info" @click="onSubmit">提交</el-button>
          <el-button type="success" @click="onBack">取消</el-button>
        </div>
      </el-form>
    </div>
  </div>
</template>

<script>
import { getSubscriptionUpgradeDates, addSubscriptionUpgradeDates } from "@/api/setting";
export default {
  data() {
    return {
      formLabelAlign: {
        confirmUpgradeDate: "",
        autoUpgradeDate: "",
        confirmUpgrade: '',
        autoUpgrade: ''
      },
    };
  },
  created() {
    this.getSubscriptionUpgradeDates();
  },
  methods: {
    onBack() {
      this.$router.go(-1);
    },
    onSubmit() {
       this.$refs.ruleForm.validate((valid) => {
          if (valid) {
               this.addSubscriptionUpgradeDates();
          } else {
            // console.log('error submit!!');
            return false;
          }
        });
    },
    addSubscriptionUpgradeDates() {
      let from = {
        confirmUpgradeDate: this.formLabelAlign.confirmUpgrade,
        autoUpgradeDate: this.formLabelAlign.autoUpgrade,
      };
      addSubscriptionUpgradeDates(from).then(() => {
        this.$message({
          message: "提交成功",
          type: "success",
        });
        this.getSubscriptionUpgradeDates()
      });
    },
    getSubscriptionUpgradeDates() {
      getSubscriptionUpgradeDates().then((res) => {
       this.formLabelAlign = res.data;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.page-box {
  background-color: #fff;
  padding: 20px;
  margin-top: 20px;
}
.unit-list {
  margin-bottom: 20px;
}
.plus-outline-add {
  display: inline-block;
}
</style>